import store from '@/store'

export default [
  {
    path: '/student-profiles',
    name: 'student-profile',
    meta: { requiresAuth: true },
    component: () => import('@/pages/student-profile/index.vue')
  },
  {
    path: '/student-profiles/create',
    name: 'student-profile-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/student-profile/create.vue')
  },
  {
    path: '/student-profiles/:id',
    name: 'student-profile-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/student-profile/edit.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('studentProfile/find', to.params.id)
      next()
    }
  },
  {
    path: '/student-profiles/:id/show',
    name: 'student-profile-show',
    meta: { requiresAuth: true },
    component: () => import('@/pages/student-profile/show.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('studentProfile/find', to.params.id)
      next()
    }
  },
  {
    path: '/student-profiles/card/by-classes',
    name: 'student-profile-card-by-class',
    meta: { requiresAuth: true },
    component: () =>
      import('@/pages/student-profile/component/card-by-class.vue')
  }
]
